export default __webpack_public_path__ + "static/media/dog_v1.c719281e.png";